package com.taocent.simple.compose.component.richtext.core.internal.serialization

import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.style.TextAlign
import com.taocent.simple.compose.component.richtext.core.internal.emoji.CUSTOM_EMOJI_TAG

/**
 * 判断 [AnnotatedString] 是否含有"富文本样式"(spans / paragraph / emoji / hyperlink)。
 *
 * 平台 `toRichClipEntry` actual 实现依据此 flag 决定是否额外写 `text/html` 副 MIME:
 *   - 有 rich → 写 text/html + text/plain(双 MIME,本组件富文本组件粘贴可还原)
 *   - 无 rich → 只写 text/plain(节省剪贴板体积,跨应用粘贴行为不变)
 *
 * 公共 API 暴露原因:[RichTextClipboardManager] (cross-module) 在写入前需要检测。
 */
fun hasRichStyles(annotated: AnnotatedString): Boolean {
    if (annotated.spanStyles.isNotEmpty()) return true
    if (annotated.paragraphStyles.any { it.item.textAlign != TextAlign.Unspecified }) return true
    if (annotated.getStringAnnotations(0, annotated.length).any {
        it.tag == "URL" || it.tag == CUSTOM_EMOJI_TAG
    }) return true
    return false
}
